import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c('autocomplete-reorderable', {
    attrs: {
      "options": _vm.stateOptions,
      "label": _vm.$t('Dashboards.components.widgetChartDataOptionsEditor.inputs.states.label'),
      "loading": _vm.isFetchingAvailableStates,
      "data-cy": "chart-data-states-select"
    },
    model: {
      value: _vm.stateIdentifiers,
      callback: function ($$v) {
        _vm.stateIdentifiers = $$v;
      },
      expression: "stateIdentifiers"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, [_c(VSwitch, {
    attrs: {
      "label": _vm.$t('Dashboards.components.widgetChartDataOptionsEditor.inputs.aggregate.enabled.label'),
      "data-cy": "chart-data-aggregation-enabled-toggle",
      "datcy-enabled": _vm.aggregationEnabled ? 'true' : 'false'
    },
    model: {
      value: _vm.aggregationEnabled,
      callback: function ($$v) {
        _vm.aggregationEnabled = $$v;
      },
      expression: "aggregationEnabled"
    }
  })], 1)], 1), _vm.editedWidget.aggregation.enabled ? _c(VRow, [_c(VCol, [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.timeFilterAggregateDurationsItems,
      "label": _vm.$t('Dashboards.components.widgetChartDataOptionsEditor.inputs.aggregate.duration.label'),
      "required": "",
      "rules": [_vm.rules.required],
      "data-cy": "chart-data-aggregation-duration"
    },
    model: {
      value: _vm.aggregationDuration,
      callback: function ($$v) {
        _vm.aggregationDuration = $$v;
      },
      expression: "aggregationDuration"
    }
  })], 1)], 1) : _vm._e(), _vm.editedWidget.aggregation.enabled ? _c(VRow, [_c(VCol, [_c(VSelect, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.timeFilterAggregateFunctionsItems,
      "label": _vm.$t('Dashboards.components.widgetChartDataOptionsEditor.inputs.aggregate.function.label'),
      "required": "",
      "rules": [_vm.rules.required],
      "data-cy": "chart-data-aggregation-function"
    },
    model: {
      value: _vm.aggregationFunction,
      callback: function ($$v) {
        _vm.aggregationFunction = $$v;
      },
      expression: "aggregationFunction"
    }
  })], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };